<template>
  <div>
    <a :class="className" @click.prevent="showModal" href="#">
      <i class="fas fa-times-circle"></i> {{ manageAccessText }}
    </a>

    <form ref="manage-access-form" :action="url" method="POST" style="display: none;">
      <input type="hidden" :value="csrf" name="_token">
      <input type="hidden" :value="reason" name="reason">
    </form>

    <!-- Bootstrap Modal for Reason Input -->
    <div ref="modal" class="modal fade" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ manageAccessText }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p>{{ questionText }} {{ explanationText }}</p>
            <input
              type="text"
              class="form-control"
              v-model="reasonInput"
              :placeholder="$t('Enter reason')"
              @keyup.enter="confirm"
              autofocus
            />
            <div v-if="showError" class="text-danger mt-2">
              {{ $t('You need to write something!') }}
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="hideModal">{{ cancelText || $t('Cancel') }}</button>
            <button type="button" class="btn btn-danger" @click="confirm">{{ manageAccessText }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'url',
    'csrf',
    'manageAccessText',
    'questionText',
    'explanationText',
    'cancelText',
    'className',
  ],
  data() {
    return {
      reason: '',
      reasonInput: '',
      modalInstance: null,
      showError: false,
    }
  },
  mounted() {
    // Assumes Bootstrap 5 JS is loaded globally
    this.modalInstance = new window.bootstrap.Modal(this.$refs.modal, {
      backdrop: 'static',
      keyboard: false,
    })
  },
  methods: {
    showModal() {
      this.reasonInput = ''
      this.showError = false
      this.modalInstance.show()
      this.$nextTick(() => {
        // Focus input after modal is shown
        const input = this.$refs.modal.querySelector('input')
        if (input) input.focus()
      })
    },
    hideModal() {
      this.modalInstance.hide()
      this.showError = false
    },
    confirm() {
      if (!this.reasonInput) {
        this.showError = true
        return
      }
      this.reason = this.reasonInput
      this.hideModal()
      this.submit()
    },
    submit() {
      this.$refs['manage-access-form'].submit()
    },
  },
}
</script>
